import { FC, useState } from "react";

import { useTheme } from "app/shared";
import { useSubscribeToWhitelistMutation } from "store/api/new.api";
import Button from "../button/button";
import styles from "./sub-form-small.module.scss";

interface ISubscribeFormSmallProps {
  isPreWl?: boolean;
  id?: number;
}

const SubscribeFormSmall: FC<ISubscribeFormSmallProps> = ({
  isPreWl,
  id = 3,
}) => {
  const [email, setEmail] = useState<string>("");
  const [subscribeToWhitelist, { isLoading }] =
    useSubscribeToWhitelistMutation();
  const { theme } = useTheme();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await subscribeToWhitelist({ email, listId: id }).unwrap();
      setEmail("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={`${
        !isPreWl ? styles.subscribeContainer : styles.subContainerPreWl
      }`}
    >
      {!isPreWl && (
        <div className={styles.textSection}>
          <p className={styles.title}>Never want to miss the next Alpha IDO?</p>
          <h2 className={styles.subtitle}>
            Sign up for our newsletter and get the latest news and updates
          </h2>
        </div>
      )}
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="email"
          placeholder="Email Address*"
          value={email}
          onChange={handleInputChange}
          className={`${styles.input} ${isPreWl ? styles.preWlInput : ""} ${
            theme === "light" ? styles.lightTheme : ""
          }`}
          required
        />
        <Button
          variant="pink"
          type="submit"
          className={`${styles.button} ${isPreWl ? styles.preWl : ""}`}
          disabled={isLoading}
        >
          {isLoading ? "Subscribing..." : "Subscribe"}
        </Button>
      </form>
    </div>
  );
};

export default SubscribeFormSmall;
